import { useMutation } from '@tanstack/react-query';
import { backendServices } from '../../services';
import { DocumentViewModel } from '../../services/backendServices/ViewModels';

export function usePostDocument() {
    const mutation = useMutation({
        mutationFn: async (body: DocumentViewModel) => {
            const api = new backendServices.Apis.DocumentApi();
            const res = await api.postDocument(body);
            return res.data;
        },
    });

    return mutation;
}
